import { useI18n } from "@/context/I18nContext";

// Renders portal_config-driven custom fields (inquiry_fields / profile_fields).
export function DynamicFields({ fields, values, onChange }) {
  const { L } = useI18n();
  if (!fields || !fields.length) return null;
  const st = {
    background: "var(--bg)", borderColor: "var(--border)",
    borderRadius: "var(--radius)", color: "var(--text)",
  };
  return (
    <div className="space-y-3">
      {fields.map((f) => {
        const label = L(f.label);
        const val = values?.[f.key] ?? "";
        const common = {
          "data-testid": `dynfield-${f.key}`,
          value: val,
          onChange: (e) => onChange(f.key, e.target.value),
          className: "w-full px-3.5 h-11 text-sm border outline-none",
          style: st,
        };
        return (
          <div key={f.key}>
            <label className="text-xs font-semibold uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>
              {label}
            </label>
            {f.type === "select" ? (
              <select {...common}>
                <option value="">—</option>
                {(f.options || []).map((o, i) => {
                  const ov = L(o);
                  return <option key={i} value={ov}>{ov}</option>;
                })}
              </select>
            ) : (
              <input type={f.type === "date" ? "date" : "text"} {...common} />
            )}
          </div>
        );
      })}
    </div>
  );
}
